// extracted by mini-css-extract-plugin
module.exports = {"chats":"Services_chats__AUlH4","chats__message":"Services_chats__message__5IX2R"};